/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import {
    Breadcrumb, Button, Panel, Tab, Tabs,
} from 'appkit-react';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import FRY9CClassifyResult from './FRY9CClassifyResult';
import FRY9CAduitLogs from '../containers/FRY9CAduitLogs';
import FRY9CComments from '../containers/FRY9CComments';
import FRY9CResultsAccordian from './FRY9CResultsAccordian';
import '../styles/fry9c.scss';

const FRY9CResults = ({
    auditLog, breadcrumbItems, refetch, onNavigate, criteria, pages, pagesize,
    setPageSize, setPageNumber, pageSizeOptions, fetchData, data, columns,
}) => {
    const history = useHistory();
    const [showClassifyResult, setShowClassifyResult] = useState(false);

    return (
        <>

            <div className="true-comply-fry9c-results_layout">
                <div className="true-comply-fry9c-results_column-2">
                    <Breadcrumb items={breadcrumbItems} />
                    <Row>
                        <Col md={4}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                                {`Rule #${(criteria && criteria.ruleId) ? criteria.ruleId : ''} Results`}
                            </div>
                        </Col>
                        <Col className="classyfy_btn_container">
                            <Row>
                                <Col style={{ textAlign: 'right' }}>
                                    <span>
                                        <Button size="lg" style={{ marginLeft: '1rem' }} onClick={() => setShowClassifyResult(true)}>
                                            CLASSIFY RESULTS
                                        </Button>
                                        {showClassifyResult
                                            && (
                                                <FRY9CClassifyResult
                                                    setShowClassifyResult={setShowClassifyResult}
                                                    refetch={auditLog.refetch}
                                                    refetchTestData={refetch}
                                                />
                                            )}
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    { /* import results accordian */ }
                    <FRY9CResultsAccordian
                        criteria={criteria}
                        columns={columns}
                        fetchData={fetchData}
                        data={data}
                        pages={pages}
                        pagesize={pagesize}
                        setPageSize={setPageSize}
                        setPageNumber={setPageNumber}
                        pageSizeOptions={pageSizeOptions}
                    />

                    <Panel style={{ marginTop: '1rem', marginBottom: '2rem' }}>
                        <Tabs defaultValue="2" className="a-tab-item-padding-10" size="md">
                            {/* <Tab value="1" label="REMEDIATION">
                                {remediation && remediation.length ? <Remediation failedTestsData={failedTestsData} refetch={auditLog.refetch} /> : (
                                    <div className="a-h4">
                                        Remediation is not allowed for passed test cases
                                    </div>
                                )}
                            </Tab> */}
                            <Tab value="2" label="COMMENTS">
                                <FRY9CComments refetch={auditLog.refetch} />
                            </Tab>
                            <Tab value="3" label="AUDIT LOG">
                                <FRY9CAduitLogs data={auditLog.data && auditLog.data.getAuditLogsForFRY9C} />
                            </Tab>
                        </Tabs>
                    </Panel>
                </div>
            </div>
        </>
    );
};

export default FRY9CResults;
